module.exports = __webpack_public_path__ + "img/file1.473042fe.svg";